var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { MultiColumnFormFields } from "@components/common/form/FormFields";
import { PeekDialog, PeekDialogContent, PeekDialogActions, PeekButton } from "@piiqtechnologies/ui-components";
import { Formik, Form } from "formik";
import { AddFeatureFormInitialValues, AddFeatureFormValidationSchema, AddFeatureFormFields } from "./AddFeatureForm";
import { useUserAccessPolicy, useError, useLoader, useNotification, useRefetch } from "@piiqtechnologies/ui-lib";
export const AddFeatureForm = ({ onClose }) => {
    const [createFeatureAccess, featureAccessCreated, createFeatureAccessInProgress, createFeatureAccessError] = useUserAccessPolicy();
    const intl = useIntl();
    const { setError } = useError();
    const { setLoader } = useLoader();
    const { setRefetch } = useRefetch();
    const { setNotification } = useNotification();
    useEffect(() => {
        setLoader(createFeatureAccessInProgress, "createFeatureAccessInProgress");
        return () => setLoader(false, "createFeatureAccessInProgress");
    }, [createFeatureAccessInProgress]);
    useEffect(() => {
        if (createFeatureAccessError) {
            setError(createFeatureAccessError === null || createFeatureAccessError === void 0 ? void 0 : createFeatureAccessError.message);
        }
    }, [createFeatureAccessError]);
    useEffect(() => {
        if (featureAccessCreated) {
            setNotification(intl.formatMessage(messages.featureSuccessCreation));
            onClose();
            setRefetch();
        }
    }, [featureAccessCreated]);
    const handleSubmit = (values) => {
        const { userIds } = values, rest = __rest(values, ["userIds"]);
        createFeatureAccess(Object.assign(Object.assign({}, rest), { userIds: (userIds === null || userIds === void 0 ? void 0 : userIds.map((user) => user.id)) || [] }));
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, fullWidth: true, title: intl.formatMessage(messages.formTitle), open: true, onClose: onClose },
        React.createElement(Formik, { initialValues: AddFeatureFormInitialValues, validationSchema: AddFeatureFormValidationSchema(), onSubmit: handleSubmit },
            React.createElement(Form, null,
                React.createElement(PeekDialogContent, null,
                    React.createElement(MultiColumnFormFields, { fullWidth: true, fields: AddFeatureFormFields() })),
                React.createElement(PeekDialogActions, null,
                    React.createElement(PeekButton, { size: "large", type: "submit", color: "primary", variant: "contained", fullWidth: true }, intl.formatMessage(messages.formTitle)))))));
};
export default AddFeatureForm;
